import { render, staticRenderFns } from "./IconPassengerCar.vue?vue&type=template&id=ab2d0e0a"
import script from "./IconPassengerCar.vue?vue&type=script&lang=js"
export * from "./IconPassengerCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports